<script setup lang="ts">

</script>

<template>
  <div class="section-2" pb-80px text-center lg:pb-180px>
    <IntroductionWhoWillWin type="2" hidden lg:block class="translate-y--90px xl:translate-y--104px" />
    <IntroductionWhoWillWin type="3" lg:hidden />

    <p mt-80px text-75px font-700 lg:mt-100px lg:text-120px class="lh-100%">
      WALLET
    </p>

    <p py-20px text-14px lg:text-24px class="lh-100%">
      1Lafcr4sA********************AbX71
    </p>

    <p lt-lg:text-9px class="lh-100%">
      Crypto Wallet with 1499 BTC will be shown during Event Day.
    </p>
  </div>
</template>

<style scoped>
.section-2 {
  background: linear-gradient(180deg, #460008, #000 60%, #000);
}
</style>
